import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PlatformService } from '@panamax/app-state';

@Component({
  selector: 'app-po-popover',
  templateUrl: './po-popover.component.html',
  styleUrls: ['./po-popover.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PoPopoverComponent {
  title = '';

  constructor(
    private modalController: ModalController,
    readonly platformService: PlatformService,
  ) {}

  async closeModal() {
    await this.modalController.dismiss();
  }

  onTitleIdentified(title: string) {
    Promise.resolve().then(() => (this.title = title));
  }

  onPoUpdate() {
    this.closeModal();
  }
}
